// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Prkt","clinicsSelect":"styles_clinicsSelect__QegCI"};